export default __webpack_public_path__ + "static/media/013-denim jacket.0d286676.svg";